import { Link } from 'react-router-dom';

interface SiteFooterProps {
  home?: boolean;
}

export default function SiteFooter({ home = false }: SiteFooterProps) {
  const anchor = (id: string) => (home ? `#${id}` : `/#${id}`);

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500">
              <i className="ri-focus-2-line text-xl text-background-50"></i>
            </div>
            <span className="text-2xl font-bold text-background-50">Acu-Comp</span>
          </Link>
          <p className="text-background-200/80 mt-4 max-w-md text-sm leading-relaxed">
            Acu-Comp delivers reliable IT services, IBM Power and storage solutions, virtualization, and
            cybersecurity for businesses across North America.
          </p>
        </div>
        <div>
          <div className="font-semibold text-background-50 mb-4">Services</div>
          <ul className="space-y-2 text-sm text-background-200/80">
            {['IBM Power Systems', 'Storage & Backup', 'Virtualization', 'Cloud Services', 'Managed Support'].map((l) => (
              <li key={l}>
                <Link to="/services" className="hover:text-accent-500 cursor-pointer">{l}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="font-semibold text-background-50 mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-background-200/80">
            <li><a href="tel:18007800632" className="cursor-pointer hover:text-accent-500">1-800-780-0632</a></li>
            <li>inquiry@acu-comp.com</li>
            <li>North America</li>
            <li><a href={anchor('contact')} className="cursor-pointer hover:text-accent-500">Request a quote</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between text-xs text-background-200/70 gap-2">
          <div>©2026 Acu-Comp. All rights reserved.</div>
          <div>Serving North America</div>
        </div>
      </div>
    </footer>
  );
}